import { Button, Spinner, Textarea } from '@design-system';

import { ChevronLeft } from 'lucide-react';

import { useState } from 'react';

interface ConsultFormProps {
  prompt: string;
  onSubmit: (details: string) => void;
  onBack: () => void;
  isPending: boolean;
}

export function ConsultForm({ prompt, onSubmit, onBack, isPending }: ConsultFormProps) {
  const [details, setDetails] = useState('');
  const canSubmit = details.trim().length > 0 && !isPending;

  return (
    <div className="mx-auto w-full max-w-xl">
      <h1 className="text-balance text-center text-3xl font-bold text-gray-950">{prompt}</h1>

      <Textarea
        className="mt-8 min-h-32"
        placeholder="Share as much detail as you'd like…"
        value={details}
        onChange={event => setDetails(event.target.value)}
        disabled={isPending}
      />

      <Button
        className="mt-6 w-full"
        size="lg"
        disabled={!canSubmit}
        onClick={() => onSubmit(details.trim())}
      >
        {isPending && <Spinner />}
        Submit
      </Button>

      <Button
        className="mt-3 w-full"
        size="lg"
        variant="outline"
        onClick={onBack}
        disabled={isPending}
      >
        <ChevronLeft />
        Back
      </Button>
    </div>
  );
}
